import React, { useState } from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import SubmitModal from './SubmitModal'

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 30,
    marginBottom: 20,
  },
  button: {
    backgroundColor: '#f9b233',
    borderRadius: 10,
    '&:hover': {
      backgroundColor: '#f98533',
    },
  },
  text: {
    marginBottom: 10,
    whiteSpace: 'pre-line',
  },
}))

export default function Submit({ onSubmit }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Grid container justify="flex-end" className={classes.root}>
        <Grid item xs={12}>
          <Typography color="textSecondary" variant="body2" className={classes.text}>
            دوست پرتلاش گارنت، اگر از همه‌ی پاسخ‌های خود مطمئن هستی، روی گزینه
            ارسال کلیک کن، روان‌شناسان و متخصصان گارنت پس از بررسی
            پاسخ‌های آزمون، تفسیر آزمون‌ها را برایت ارسال می‌کنند.
            گارنت در مسیر دانایی یار و همراهت می‌ماند.
          </Typography>
        </Grid>
        <Grid item>
          <Button onClick={() => setOpen(true)} className={classes.button} variant="contained">ارسال پاسخ</Button>
        </Grid>
        <SubmitModal
          open={open}
          onClose={() => setOpen(false)}
          onSubmit={onSubmit}
        />
      </Grid>
    </>
  )
}
